<template>
  <span>
    <snackbar ref="snackbar" baseSize="100px" :holdTime="3000" />
    <input
      type="text"
      ref="bankNumber"
      :value="to"
      v-autowidth="{ comfortZone: 0 }"
      style="
        border: 0;
        background: transparent;
        text-decoration: underline;
        cursor: pointer;
      "
      :style="{ color: theme.color }"
      readonly
      @click="onCopy"
    />
  </span>
</template>

<script>
import Vue from 'vue'
import VueInputAutowidth from 'vue-input-autowidth'
import VueClipboard from 'vue-clipboard2'
import Snackbar from 'vuejs-snackbar'
import { mapGetters } from 'vuex'

Vue.use(VueInputAutowidth)
Vue.use(VueClipboard)

export default {
  props: ['to'],
  components: {
    Snackbar
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  methods: {
    onCopy: function () {
      var vm = this
      vm.$copyText(vm.to).then(
        function (e) {},
        function (e) {}
      )
      vm.$nextTick(function () {
        vm.$refs.bankNumber.select()
        vm.$refs.snackbar.info('Copied!!')
      })
    }
  }
}
</script>
